import React from 'react'
import qs from 'qs';
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../comum/Titulo';
import {PERFIL_ADMIN, PERFIL_GESTOR_EMPRESA, getAdminEmpresa, getGestorEmpresa, hasPerfil} from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import ModalCadastrarConfiguracaoBPe from './ModalCadastrarConfiguracaoBPe';
import ModalCadastrarControleEmissaoBPe from './ModalCadastrarControleEmissaoBPe';
import ConfiguracaoBpe from './ConfiguracaoBpe';
import buscarEmpresa from '../../actions/empresa/buscarEmpresas';
import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import {
  ativarConfiguracaoBpe,
  desativarConfiguracaoBpe,
  buscarConfiguracoesBPe,
  importarConfiguracaoBPe,
  excluirConfiguracaoBPe}
  from '../../actions/configuracao-bpe/configuracaoBPeActions';
import ModalImportarConfiguracaoBPe from './ModalImportarConfiguracoesBPe';
import ModalCadastrarControleEmissaoBPeEmLote from './ModalCadastrarControleEmissaoBPeEmLote';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import ModalPainelRegraControleEmissaoBpe from './ModalPainelRegraControleEmissaoBpe';

const ModalConfirmacaoInativacaoConfiguracao = ({ inativar, atualizarCheckBox }) => (
  <div className="modal fade" id="ModalConfirmacaoInativacaoConfiguracao" tabIndex="-1" role="dialog"
       aria-labelledby="ModalConfirmacaoInativacaoConfiguracao" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body texto-centralizado">
          <p>Confirmar inativação da configuração? </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-outline-secondary"
                  data-dismiss="modal" onClick={() => atualizarCheckBox()}>Cancelar
          </button>
          <button type="button" className="btn btn-azul float-left" data-dismiss="modal"
                  onClick={() => inativar()}>Desativar
          </button>
        </div>
      </div>
    </div>
  </div>);


export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2">Razão social</div>
      <div className="col-md-2 col-md-2">Nome fantasia</div>
      <div className="col-md-2 col-md-2">CNPJ</div>
      <div className="col-md-2 col-md-2">Inscrição Estadual</div>
      <div className="col-lg-1 col-xl-1">Validade</div>
      <div className="col-lg-1 col-xl-1">Estado</div>
      <div className="col-lg-2 col-xl-2">Ações</div>
    </div>
  </div>
);

const ModalConfirmacaoExclusaoConfiguracaoBpe = ({excluir}) => (
  <div className="modal fade" id="modalConfirmacaoExclusaoConfiguracaoBpe" tabIndex="-1" role="dialog"
       aria-labelledby="modalConfirmacao" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
              <div className="modal-body texto-centralizado">
                  <p>Deseja excluir a configuração selecionada?</p>
              </div>
              <div className="modal-footer ">
                  <button id='cancelar' type="button" className="btn btn-outline-secondary"
                          data-dismiss="modal">Cancelar
                  </button>
                  <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                          onClick={() => excluir()}>Excluir
                  </button>
              </div>
          </div>
      </div>
  </div>);


export class PainelConfiguracaoBPe extends React.Component {
  constructor (props) {
    super(props);
    this.selecionarEmpresa = this.selecionarEmpresa.bind(this);
    this.limparCampos = this.limparCampos.bind(this);

    this.state = {
      codigoEmpresaSelecionada: null,
      seHabilitadaBPe: false,
      configuracaoBPeSelecionada: null,
      textoFiltro: null,
      arquivo: null,
      controleEmissaoBpe: [],
      pagina: null,
      tipoControleBpeSelecionado: '',
      regimeTributario: null
    };
  }

  ativar(configuracaoBPeSelecionada) {
    this.props.ativarConfiguracaoBpe(configuracaoBPeSelecionada.id)
      .then(() => {
        this.props.buscarConfiguracoesBPe(configuracaoBPeSelecionada.codigoEmpresa)
      });
  }

  inativar() {
    this.props.desativarConfiguracaoBpe(this.state.configuracaoBPeSelecionada.id).then(() => {
      this.props.buscarConfiguracoesBPe(this.state.configuracaoBPeSelecionada.codigoEmpresa)
    });
  }

  atualizarCheckBox() {
    document.getElementById(this.state.configuracaoBPeSelecionada.id).checked = true;
  }


  componentDidMount () {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (parametros.codigoEmpresa) {
      const habilitada = parametros.habilitadaBPe === 'true'
      this.setState({
            codigoEmpresaSelecionada: parametros.codigoEmpresa,
        seHabilitadaBPe: habilitada,
        pagina: parametros.pagina ? parametros.pagina : 'gestao'
          }
      )
      this.props.buscarConfiguracoesBPe(parametros.codigoEmpresa)      
      this.props.buscarEmpresaPorId(parametros.codigoEmpresa)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.setState({
        codigoEmpresaSelecionada: this.props.empresaSelecionada.id,
      })
      window.location.href = window.location.href.replace(window.location.search, '?codigoEmpresa='+this.props.empresaSelecionada.id)      
    }
  }


  selecionarEmpresa (empresa) {
    this.setState({ empresaSelecionada: empresa });
  }

  selecionaregimeTributario(regimeTributario) {
    this.setState({regimeTributario} )
  }

  buscarConfiguracoesBPe () {
    this.props.buscarConfiguracoesBPe(this.state.codigoEmpresaSelecionada)
  }

  limparEmpresaSelecionado () {
    this.setState({ empresaSelecionada: null });
  }

  excluir () {
    this.props.excluirConfiguracaoBPe(this.state.configuracaoBPeSelecionada.id)
      .then(() => {
          this.buscarConfiguracoesBPe();
          this.limparEmpresaSelecionado();
      })
  }

  selecionarOrigem (origem) {
    this.props.selecionarOrigem(origem);
  }

  limparCampos () {
    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'idEmpresa', '');
    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'nome', '');
    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'email', '');
    this.limparEmpresaSelecionado();
  }

  // eslint-disable-next-line class-methods-use-this
  montarParametroConfiguracao (values) {      
    return {
      id: values.codigoConfiguracaoBPe,
      codigoEmpresa: values.codigoEmpresa ? values.codigoEmpresa : this.state.codigoEmpresaSelecionada,
      cnpj: values.cnpj,
      ie: values.ie,
      cnae: values.cnae,
      im: values.im,
      tar: values.tar,
      regimeTributario: this.state.regimeTributario ? this.state.regimeTributario.value : null,
      razaoSocial: values.razaoSocial,
      nomeFantasia: values.nomeFantasia,
      email: values.email,
      numeracao: values.numeracao,
      endereco: {
        id: values.idEndereco,
        cep: values.cep,
        logradouro: values.logradouro,
        complemento: values.complemento,
        bairro: values.bairro,
        codigoCidade: this.props.origem.id,
        uf: this.props.origem.uf,
        numero: values.numero
      },
      // eslint-disable-next-line no-undef
      habilitadaBpe: _.isNil(values.habilitadaBpe) ? false: values.habilitadaBpe,
      senhaCertificado: values.senhaCertificado,
      nomeCertificado: values.nomeCertificado,
      telefone: values.telefone
    };
  }

  selecionarConfiguracao (configuracaoBPeSelecionada) { 
      const controles = configuracaoBPeSelecionada.controlesEmissaoBpe.map(it => ({
        id: it.id,
        hash: it.uuid,
        horaInicio: `${it.horaInicio}`,
        horaFim: `${it.horaFim}`,
        configBpe: it.configBpe
      }))
    
    this.setState({ configuracaoBPeSelecionada: configuracaoBPeSelecionada, controleEmissaoBpe: controles });
  }

  removerControle(controle) {
    this.setState({ controleEmissaoBpe: this.state.controleEmissaoBpe.filter(it => !(it.hash == controle.hash)) })
  }

  adicionarControle(event, controle) {
    event.preventDefault();
    if (this.state.controleEmissaoBpe.filter(it => it.hash == controle.hash).length == 0) {
      const controleEmissaoBpe = this.state.controleEmissaoBpe;
      controleEmissaoBpe.push(controle);

      this.setState({ controleEmissaoBpe });
    }
  }

  limparControleEmissaoBpe() {
    this.setState({ controleEmissaoBpe: [] });
  }

  // eslint-disable-next-line class-methods-use-this
  exibirBotaoNovaConfiguracao () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
        <div className="row">
          <div className="col-12">
            <div className="float-right">
              <button data-toggle="modal"
                      data-target="#modalCadastrarConfiguracaoBPe"
                      className="btn btn-laranja">
                Nova Configuração
              </button>
            </div>
            <div>
              <button data-toggle="modal"
                      data-target="#modalImportarConfiguracaoBPe"
                      className="btn btn-laranja" onClick={() => {
                          if (validaPerfis([PERFIL_ADMIN])) {
                            this.props.buscarEmpresa()
                          }
                      }}>
                Importar configuração
              </button>
            </div>
            
          </div>
        </div>
      </Autorizacao>)
  }

  exibirBotaoCadastrarControleEmissaoBpeEmLote () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN, PERFIL_GESTOR_EMPRESA]}>
        <div className="row">
          <div className="col-12">
            <div className="float-right" style={{ marginBottom: '2px' }}>
              <button data-toggle="modal"
                      data-target="#modalCadastrarControleEmissaoBPeEmLote"
                      className="btn btn-laranja">
                Cadastrar Emissão Bpe em Lote
              </button>
            </div>      
          </div>
        </div>
      </Autorizacao>)
  }

  exibirBotaoPainelRegraControleEmissaoBpe() {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN, PERFIL_GESTOR_EMPRESA]}>
        <div className="row">
          <div className="col-12">
            <div className="float-right" style={{ marginBottom: '2px' }}>
              <button data-toggle="modal"
                data-target="#modalPainelRegraControleEmissaoBpe"
                className="btn btn-laranja"
                onClick={() => {
                  this.setState({
                    tipoControleBpeSelecionado: this.props.tipoControle
                  })
                }}>
                Painel Selecionar Regra Controle Emissão BPe
              </button>
            </div>
          </div>
        </div>
      </Autorizacao>)
  }

  checkedFieldTipoControle(valor) {
      this.setState({
        tipoControleBpeSelecionado: valor
      })
  }

  limparCheckedTipoControle() {
    this.setState({
      tipoControleBpeSelecionado: ''
    })
  }

  exibirTabelaEmpresas () {
    if (this.props.configuracoesBPe) {
      return (<div>
          <CabecalhoTabela/>
          <div className="lista-tabela-dados">
            {this.exibirEmpresas()}
          </div>

        </div>
      )
    }
    return <div>Nenhum empresa cadastrada.</div>;
  }

  exibirEmpresas () {
    return this.props.configuracoesBPe
      .map((configuracao, index) => <ConfiguracaoBpe key={`configuracao_bpe_${configuracao.id}`}
                                                     configuracao={configuracao}
                                                     selecionarOrigem={this.selecionarOrigem.bind(this)}
                                                     buscarConfiguracoesBPe={this.buscarConfiguracoesBPe.bind(this)}
                                                     selecionarConfiguracao={this.selecionarConfiguracao.bind(this)}
                                                     empresaSelecionada={this.props.empresaSelecionada}
                                                     regraControleEmissaoBpe={this.props.tipoControle}
                                                     ativar={this.ativar.bind(this)} 
                                                     indice={index}/>)
  }

  getRetornoPainel() {
    if (hasPerfil(PERFIL_ADMIN)) {      
      if (this.state.pagina == 'empresa') {
        return '/painel-empresas';  
      } else {
        return '/gestao-empresa';  
      }      
    } else {      
      return '/gestao-empresa';
    }
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
        <div>
          <div className="mt-2 alert alert-warning" role="alert">
            Atenção! Antes de cadastrar uma nova configuração verifique
            <a target="_BLANK" href='https://dfe-portal.svrs.rs.gov.br/Bpe/Ccc' rel='noreferrer'> aqui </a>
            se a empresa está habilitada.

          </div>
          <div className="row internas">
            <Titulo texto="Gerenciar Configurações BPe" urlRetorno={this.getRetornoPainel()}/>
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
              {this.exibirBotaoPainelRegraControleEmissaoBpe()}
              {this.exibirBotaoCadastrarControleEmissaoBpeEmLote()}
              {this.exibirBotaoNovaConfiguracao()}
              {this.exibirTabelaEmpresas()}
            </div>
          </div>
          <ModalImportarConfiguracaoBPe
            empresas={this.props.empresas}
            buscarConfiguracoesBPe={this.props.buscarConfiguracoesBPe}
            codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}
            importarConfiguracaoBPe={this.props.importarConfiguracaoBPe}/>
          <ModalCadastrarConfiguracaoBPe
            selecionarOrigem={this.selecionarOrigem.bind(this)}
            cidade={this.props.origem}
            montarParametroConfiguracao={this.montarParametroConfiguracao.bind(this)}
            codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}
            seHabilitadaBPe={this.state.seHabilitadaBPe}
            selecionaregimeTributario={this.selecionaregimeTributario.bind(this)}
            regimeTributario={this.state.regimeTributario}
            codigoEmpresaSelecinada={this.props.empresaSelecionada}/>
          <ModalCadastrarControleEmissaoBPe 
            configuracaoBPeSelecionada={this.state.configuracaoBPeSelecionada}
            selecionarConfiguracao={this.selecionarConfiguracao.bind(this)}
            codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}
            buscarConfiguracoesBPe={this.buscarConfiguracoesBPe.bind(this)}
            removerControle={this.removerControle.bind(this)}
            adicionarControle={this.adicionarControle.bind(this)}
            controleEmissaoBpe={this.state.controleEmissaoBpe}
            limparControleEmissaoBpe={this.limparControleEmissaoBpe.bind(this)}
           />
           <ModalCadastrarControleEmissaoBPeEmLote
           configuracaoBPeSelecionada={this.state.configuracaoBPeSelecionada}
           selecionarConfiguracao={this.selecionarConfiguracao.bind(this)}
           codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}
           buscarConfiguracoesBPe={this.buscarConfiguracoesBPe.bind(this)}
           removerControle={this.removerControle.bind(this)}
           adicionarControle={this.adicionarControle.bind(this)}
           controleEmissaoBpe={this.state.controleEmissaoBpe}
           limparControleEmissaoBpe={this.limparControleEmissaoBpe.bind(this)}
           />
          <ModalPainelRegraControleEmissaoBpe
            codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}
            buscarConfiguracoesBPe={this.buscarConfiguracoesBPe.bind(this)}
            empresaSelecionada={this.props.empresaSelecionada}
            checkedFieldTipoControle={this.checkedFieldTipoControle.bind(this)}
            tipoControleBpeSelecionado={this.state.tipoControleBpeSelecionado}
            limparCheckedTipoControle={this.limparCheckedTipoControle.bind(this)}
          />
          <ModalConfirmacaoInativacaoConfiguracao inativar={this.inativar.bind(this)} atualizarCheckBox={this.atualizarCheckBox.bind(this)}/>
          <ModalConfirmacaoExclusaoConfiguracaoBpe excluir={this.excluir.bind(this)} selecionarConfiguracao={this.selecionarConfiguracao.bind(this)}/>
        </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = (state) => {
  return {
    configuracoesBPe: state.configuracaoBPe.configuracoesBPe,
    empresaSelecionada: state.empresaSelecionada,
    origem: state.origem,
    changeFieldValue,
    empresas: state.empresas,
    tipoControle: state.empresa.empresa.tipoControleEmissaoBPe.chave
  }};

export default connect(mapStateToProps,
  {
    buscarConfiguracoesBPe,
    selecionarOrigem,
    ativarConfiguracaoBpe,
    desativarConfiguracaoBpe,
    importarConfiguracaoBPe,
    buscarEmpresa,
    excluirConfiguracaoBPe,
    buscarEmpresaPorId
  })(reduxForm({
  form: 'formCadastrarConfiguracaoBPe'
})(PainelConfiguracaoBPe))
